import { EMAIL_REGEX } from "GlobalShared/common/Constants";
export function validateEmail(email) {
  return EMAIL_REGEX.test(email);
}
